import React from "react";

const HowItWorks = ({ data }) => {
  const howItWorksData = data?.howItWorks || {
    title: "HOW IT WORKS",
    subtitle: "It's so easy & convenient to use Nexagen products & Online Portals. It can be done in following 3 easy steps:",
    steps: [
      {
        number: "01",
        title: "Registration",
        description: "Simply register with Product & Demo you are looking for. Our Team will confirm your registration & will active your ID."
      },
      {
        number: "02",
        title: "Demo",
        description: "Our Support Team will contact you will arrange an online Demo for you, You will be Eligible for 15 days Free Trial with no initial fee."
      },
      {
        number: "03",
        title: "Annual Charges",
        description: "After you satisfied with our product you can subscribe annual charges for selected Demo."
      }
    ]
  };

  return (
    <section id="how-it-works" className="section">
      <div className="container">
        <div className="section-title">
          <h2>{howItWorksData.title}</h2>
          <p>{howItWorksData.subtitle}</p>
        </div>

        <div className="steps-container">
          {howItWorksData.steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;